import React, { useState } from "react";
import "./partnerships.css";
import { Link } from "react-router-dom";

export default function Partnerships() {
  const [selectedType, setSelectedType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const form = e.target;

    const data = {
      name: form.name.value,
      email: form.email.value,
      organization: form.organization.value,
      message: form.message.value,
      type: form.type.value,
      otherTypeDetail:
        form.type.value === "other" ? form.otherTypeDetail.value.trim() : "",
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_API}partnerships`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (res.ok) {
        window.location.href = "/partnerships-thank-you";
      } else {
        const err = await res.json();
        alert(`Error: ${err.message || "Something went wrong."}`);
      }
    } catch (err) {
      console.error(err);
      alert("Submission failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="partnerships-container">
      <section className="partnerships-hero">
        <h1>Partner With Us</h1>
        <p>
          We champion writers—and we’re inviting aligned brands to join us. Let’s amplify voices, deliver real value, and make a lasting impact—together.
        </p>
      </section>
      <section className="partnerships-section">
        <h2>Our Value Driven Partnership Model</h2>
        <p>
          We collaborate with brands, creators and organizations who share our values. In exchange for offering perks to our annual subscribers, we’ll promote your brand, drive traffic your way, and reward every referral.
        </p>
      </section>
      <section className="partnerships-section">
        <h2>How It Works</h2>
        <ol>
          <li><strong>Share an Offer</strong> – A discount or exclusive perk for our annual subscribers.</li>
          <li><strong>Get featured</strong> – We promote you across our site, newsletters, and socials.</li>
          <li><strong>Receive a Unique Promo Code</strong> – Give your audience $20 off our Annual Plan.</li>
          <li><strong>Earn $30</strong> – For every new annual subscriber you refer.</li>
        </ol>
      </section>
      <section className="partnerships-section">
        <h2>Why It Works</h2>
        <ul>
          <li><strong>Reach a growing, loyal audience</strong> of engaged readers and writers.</li>
          <li><strong>Deliver value</strong> with perks your audience will appreciate.</li>
          <li><strong>Earn $30 per annual subscriber</strong> who uses your unique promo code.</li>
          <li><strong>Position your brand</strong> alongside a mission-driven movement.</li>
          <li><strong>Get featured</strong> on our site, newsletters, and socials.</li>
        </ul>
      </section>
      <section className="partnerships-section">
        <h2>Ways to Partner With Us</h2>
        <ul>
          <li><strong>Retail Partnerships</strong> – Feature our subscription at checkout or post-purchase and offer something valuable to your customers while introducing your brand to our members.</li>
          <li><strong>Influencer Partnerships</strong> – Inspire your audience by sharing something meaningful: a platform that aligns with your values, plus a special offer that reflects your brand’s voice. Ideal for creators who lead with trust and authenticity.</li>
          <li><strong>Affiliate Partnerships</strong> – Embed our special subscription offer into your existing content, emails, or recommendations. Perfect for those with blogs, resource pages, or newsletters.</li>
          <li><strong>Educational Institutions & Nonprofits</strong> – Offer discounted access to your community while we feature and support your organization through a custom, mission-aligned partnership.</li>
        </ul>
      </section>
      <section className="partnerships-section">
        <h2>Ready to Collaborate?</h2>
        <p style={{ marginBottom: "15px" }}>
          We’re always looking to work with aligned brands, creators, and organizations. If you'd like to be featured as an exclusive partner — and earn rewards for every referral — fill out the form below and tell us more about your brand.
        </p>

        <form className="partnerships-form" onSubmit={handleSubmit} autoComplete="off">
          <label>
            Name*
            <input type="text" name="name" required />
          </label>
          <label>
            Email*
            <input type="email" name="email" required />
          </label>
          <label>
            Organization (optional)
            <input type="text" name="organization" />
          </label>
          <label>
            Partnership Type*
            <select
              name="type"
              defaultValue=""
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              required
            >
              <option value="" disabled hidden>Select one...</option>
              <option value="retail">Retail Partner</option>
              <option value="influencer">Influencer</option>
              <option value="affiliate">Affiliate Partner</option>
              <option value="nonprofit">Nonprofit / Educational Institution</option>
              <option value="other">Other</option>
            </select>
          </label>
          {selectedType === "other" && (
            <label>
              Please describe your partnership type<span aria-hidden="true">*</span>
              <input type="text" name="otherTypeDetail" required minLength={3} />
            </label>
          )}
          <label>
            Tell us about your audience and what kind of offer you’d like to share*
            <textarea name="message" rows="5" required />
          </label>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Sending..." : "Submit Proposal"}
          </button>
        </form>
      </section>

      <div className="back-link">
        <Link to="/">← Back to Home</Link>
      </div>
    </div>
  );
}
